'use client';
import { createContext } from 'react';
import { AllowedWidths } from '../components/Slideover';

interface SlideoverContext {
  needsConfirmation: boolean;
  setNeedsConfirmation: (bool: boolean) => void;

  slideOpen: boolean;
  setSlideOpen: (bool: boolean) => void;

  slideTitle: string;
  setSlideTitle: (title: string) => void;

  slideContent: React.ReactNode | null;
  setSlideContent: (content: React.ReactNode) => void;

  slideWidth: AllowedWidths;
  setSlideWidth: (width: AllowedWidths) => void;
}

export const PropertyPageSlideoverContext = createContext<SlideoverContext>({
  needsConfirmation: false,
  setNeedsConfirmation: bool => {},

  slideOpen: false,
  setSlideOpen: bool => {},

  slideTitle: '',
  setSlideTitle: title => {},

  slideContent: null,
  setSlideContent: content => {},

  slideWidth: 'standard',
  setSlideWidth: width => {},
});
